module.exports = __webpack_public_path__ + "img/syllabus-level1-line.5939ba91.png";